export default class Config {
    // This is pointing to tungsmat AWS account.
    // Will leave it here since we actually want analytics in dev env
    // TODO: Make a dev env file to populate these values per developer
    public static readonly COGNITO_IDENTITY_POOL_ID_DEV = 'us-west-2:e6ac6644-1fdb-4c25-b937-97055064600a';
    public static readonly PINPOINT_APP_ID_DEV = 'f89f2d057481475583d08930f4ab4717';
}
